import React, { useState } from 'react';
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnUndo,
  BtnRedo,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnStrikeThrough,
  BtnBulletList,
  BtnNumberedList,
  BtnLink,
  BtnClearFormatting,
} from 'react-simple-wysiwyg';

const EditorComponent = ({ value = '', onChange }) => {
  const [lastEdited, setLastEdited] = useState(new Date());

  function onChangeEditor(e) {
    const newValue = e.target.value;

    if (onChange) {
      onChange(newValue);
    }

    setLastEdited(new Date());
  }

  const applyColor = (color) => {
    document.execCommand('foreColor', false, color);
  };

  const getWordCount = (htmlContent) => {
    const text = htmlContent.replace(/<[^>]*>/g, ' ');
    return text.trim().split(/\s+/).filter(Boolean).length;
  };

  const wordCount = getWordCount(value);

  const formatLastEdited = (date) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
  };

  return (
    <div
      style={{
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: 'white',
        marginBottom: '24px',
      }}
    >
      <EditorProvider>
        <Toolbar>
          <BtnUndo />
          <BtnRedo />

          <BtnBold />
          <BtnItalic />
          <BtnUnderline />
          <BtnStrikeThrough />

          <BtnBulletList />
          <BtnNumberedList />

          <BtnLink />

          <BtnClearFormatting />
          <input
            type="color"
            onChange={(e) => applyColor(e.target.value)}
            style={{ marginLeft: 8 }}
          />
        </Toolbar>

        <Editor value={value} onChange={onChangeEditor} />
      </EditorProvider>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '12px 16px',
          borderTop: '1px solid #ddd',
          fontSize: '13px',
          color: '#666',
        }}
      >
        <span>Word count: {wordCount}</span>
        <span>Last edited on {formatLastEdited(lastEdited)}</span>
      </div>
    </div>
  );
};

export default EditorComponent;
